var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { CircularProgress as MuiCircularProgress, styled, } from '@mui/material';
import React from 'react';
var Root = styled('div', {
    name: 'MuiCircularProgress',
    overridesResolver: function (_a) {
        var theme = _a.theme;
        return [theme.components.MuiCircularProgress.customOverrides.root];
    },
})({});
var SMuiCircularProgressBottom = styled(MuiCircularProgress, {
    name: 'MuiCircularProgress',
    overridesResolver: function (_a) {
        var theme = _a.theme;
        return [theme.components.MuiCircularProgress.customOverrides.bottom];
    },
})({});
var SMuiCircularProgressTop = styled(MuiCircularProgress, {
    name: 'MuiCircularProgress',
    overridesResolver: function (props) { return [props.theme.components.MuiCircularProgress.customOverrides.top]; },
})({});
var Spinner = function (_a) {
    var props = __rest(_a, []);
    return (React.createElement(Root, null,
        React.createElement(SMuiCircularProgressBottom, __assign({ "aria-label": "spinner-bottom", variant: "determinate" }, props, { value: 100 })),
        React.createElement(SMuiCircularProgressTop, __assign({ "aria-label": "spinner-top" }, props))));
};
export default Spinner;
